import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { TeamsService } from 'src/app/chat/core/services/teams.service';

/**
 * For pages that make no sense inside Microsoft Teams. The /local-models page, for one, is the download page of
 * the desktop app: its Mac/Windows downloads do nothing in the Teams webview, and Microsoft's store review asked
 * for it to be hidden there. A link or a stale history entry that lands there is sent to the app's entry point.
 *
 * The Teams detection is shared and cached (the auth guard runs it too), and resolves at once outside an iframe.
 */
export const notInTeamsGuard = (async () => {
  const router = inject(Router);
  const inTeams = await inject(TeamsService).ensureTeamsDetected();
  return inTeams ? router.createUrlTree(['/']) : true;
}) satisfies CanActivateFn;
